import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled, Typography } from '@ori-ui/mui';
import { ARTICLE_BOX_DESKTOP_WIDTH, ARTICLE_BOX_MOBILE_WIDTH } from "./constants";
export var Root = styled('a')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    color: theme.palette.text.primary,
    display: 'block',
    textAlign: 'center',
    textDecoration: 'none',
    maxWidth: ARTICLE_BOX_MOBILE_WIDTH,
    '&:active, &:focus, &:hover': {
      color: theme.palette.text.secondary,
      WebkitTapHighlightColor: 'transparent'
    }
  }, theme.breakpoints.up('sm'), {
    maxWidth: ARTICLE_BOX_DESKTOP_WIDTH
  });
});
export var ImageWrapper = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    borderRadius: theme.spacing(1),
    height: 170,
    marginBottom: theme.spacing(3),
    overflow: 'hidden',
    position: 'relative',
    img: {
      height: '100%',
      left: 0,
      objectFit: 'cover',
      objectPosition: '50% 50%',
      position: 'absolute',
      top: 0,
      width: '100%'
    }
  };
});
export var Category = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: '1.5',
    marginBottom: theme.spacing(3),
    textTransform: 'uppercase'
  };
});
export var Title = styled(Typography)(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.palette.text.secondary,
    display: '-webkit-box',
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(0, 0, 1, 0),
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
  };
});
export var Intro = styled(Typography)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    color: theme.palette.text.secondary,
    display: '-webkit-box',
    fontSize: theme.typography.pxToRem(14),
    margin: theme.spacing(0, 0, 2, 0),
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2
  };
});
export var LinkLabel = styled('span')(function (_ref7) {
  var theme = _ref7.theme;
  return {
    borderBottom: '2px solid',
    display: 'inline-block',
    fontSize: theme.typography.pxToRem(10),
    fontWeight: theme.typography.fontWeightBold,
    padding: '0 4px 2px 4px',
    textTransform: 'uppercase',
    '&:hover': {
      textShadow: '0.5px 0 0 currentColor'
    }
  };
});
//# sourceMappingURL=styles.js.map